import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

const STORAGE_KEY = "valmerantio_cookie_consent_v1";

const applyConsent = (granted) => {
  if (typeof window === "undefined") return;
  if (!window.gtag) return;
  const state = granted
    ? {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      }
    : {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
      };
  window.gtag("consent", "update", state);
};

export default function CookieBanner() {
  const { locale, t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (_) {}
  };

  const handleAccept = () => {
    persist("granted");
    applyConsent(true);
    setVisible(false);
  };
  const handleReject = () => {
    persist("denied");
    applyConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-[#dbe4ea] bg-white shadow-2xl"
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-5 py-5 md:flex-row md:items-center md:justify-between md:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold text-[#0b3d5c]" data-testid="cookie-banner-title">
            {t("cookieBanner.title")}
          </p>
          <p className="mt-1 text-sm leading-relaxed text-[#4b5f70]">
            {t("cookieBanner.text")}{" "}
            <Link
              to={`/${locale}/cookie-policy`}
              className="font-semibold text-[#0f5c3f] underline underline-offset-2 hover:text-[#0b3d5c]"
              data-testid="cookie-banner-more-info"
            >
              {t("cookieBanner.moreInfo")}
            </Link>
          </p>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={handleReject}
            className="rounded-full border border-[#0b3d5c] px-5 py-2 text-sm font-semibold text-[#0b3d5c] hover:bg-[#f2f6f9]"
            data-testid="cookie-reject-button"
          >
            {t("cookieBanner.rejectAll")}
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="rounded-full bg-[#0f5c3f] px-5 py-2 text-sm font-semibold text-white hover:bg-[#0d4d35]"
            data-testid="cookie-accept-button"
          >
            {t("cookieBanner.acceptAll")}
          </button>
        </div>
      </div>
    </div>
  );
}
